import { Flow } from "../types/IFlow";
import {
  SingleMedicalStepDefaultNavigatorConfiguration,
  SingleMedicalStepPreQualifiedPatientNavigatorConfiguration
} from "./NavigatorConfigurations";
import {
  experimentalScreeningStepConfigurations,
  noConfirmationStaticCenterBookingStepConfigurations
} from "./StepConfigurations";

const singleMedicalStepRebookFlowName = "SingleMedicalStepRebookFlow";

/** The treatment flow where a rebook guest experiences the single-page medical presentation. */
class SingleMedicalStepRebookFlow extends Flow {
  static readonly flowName = singleMedicalStepRebookFlowName;
  readonly name = singleMedicalStepRebookFlowName;
  readonly steps = {
    ...experimentalScreeningStepConfigurations,
    ...noConfirmationStaticCenterBookingStepConfigurations
  };
  readonly navigatorItems = [...SingleMedicalStepDefaultNavigatorConfiguration];
  isDisqualificationPossible() {
    return true;
  }
}

/** The treatment flow for pre-qualified rebook guests (scheduling-only path). */
export class PreQualifiedSingleMedicalStepRebookFlow extends Flow {
  readonly name = singleMedicalStepRebookFlowName;
  readonly steps = { ...noConfirmationStaticCenterBookingStepConfigurations };
  readonly navigatorItems = [...SingleMedicalStepPreQualifiedPatientNavigatorConfiguration];
  isDisqualificationPossible() {
    return false;
  }
}

export default SingleMedicalStepRebookFlow;
